// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"875":"344cd931","986":"d901b634"}[chunkId] + ".chunk.css";
};